module.exports = __webpack_public_path__ + "img/landscape_9.3715bf88.jpg";